function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

var SubContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SubContent, _PureComponent);

  function SubContent() {
    _classCallCheck(this, SubContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(SubContent).apply(this, arguments));
  }

  _createClass(SubContent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          subContentOne = _this$props.subContentOne,
          subContentTwo = _this$props.subContentTwo,
          subContentThree = _this$props.subContentThree,
          subContentFour = _this$props.subContentFour,
          subContentLast = _this$props.subContentLast,
          isConsumer = _this$props.isConsumer,
          hasTwoActionButtons = _this$props.hasTwoActionButtons;
      var contentClassNames = 'eds-text-bs--fixed eds-text-color--ui-600 eds-l-mar-top-1';
      var contentClassNamesLast = 'eds-text-bs--fixed eds-text-color--ui-600 eds-l-mar-top-3';

      if (isConsumer) {
        var consumerClassNames = classNames('eds-event-card-content__sub', 'eds-text-bm', 'eds-text-color--ui-600', 'eds-l-mar-top-1', {
          'eds-event-card-content__sub--cropped': hasTwoActionButtons
        });
        var subContent = [subContentOne, subContentTwo, subContentThree, subContentFour, subContentLast].map(function (content) {
          var component = null;

          if (content) {
            component = React.createElement("div", {
              key: content,
              className: consumerClassNames
            }, content);
          }

          return component;
        });
        return React.createElement("div", {
          className: "eds-event-card-content__sub-content"
        }, subContent);
      }

      return React.createElement("div", {
        className: "eds-event-card-content__sub-content"
      }, React.createElement("div", {
        className: contentClassNames
      }, subContentOne), React.createElement("div", {
        className: "eds-event-card-content__sub-content-cropped"
      }, React.createElement("div", {
        className: contentClassNames
      }, subContentTwo), React.createElement("div", {
        className: contentClassNames
      }, subContentThree), React.createElement("div", {
        className: contentClassNames
      }, subContentFour), React.createElement("div", {
        className: contentClassNamesLast
      }, subContentLast)));
    }
  }]);

  return SubContent;
}(PureComponent);

_defineProperty(SubContent, "propTypes", {
  subContentOne: PropTypes.node,
  subContentTwo: PropTypes.node,
  subContentThree: PropTypes.node,
  subContentFour: PropTypes.node,
  subContentLast: PropTypes.node,
  isConsumer: PropTypes.bool,
  hasTwoActionButtons: PropTypes.node
});

export { SubContent as default };